import { RootState } from 'redux/reducers/rootReducer';

const internalRecruitersListSelector = (state: RootState) =>
  state.recruiter.allMyInternalRecruiters;
const recruiterCreatedAtSelector = (state: RootState) =>
  state.recruiter.recruiterCreatedAt;
const memberDetailsUpdatedAtByAdminSelector = (state: RootState) =>
  state.recruiter.memberDetailsUpdatedAtByAdmin;
const recruiterDetailsSelector = (state: RootState) =>
  state.recruiter.recruiterDetails;

export {
  internalRecruitersListSelector,
  recruiterCreatedAtSelector,
  recruiterDetailsSelector,
  memberDetailsUpdatedAtByAdminSelector,
};
